import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../redux/hooks";
import { useEffect, useMemo, useState } from "react";
import { PageDS, TabMenu, ToastContainerDS } from "@qivia/ui";
import { selectCompany, selectManager } from "../../homeSlice";
import { StatementTab } from "../archives/statementsTab";
import { useNavigate, useParams } from "react-router-dom";
import { InvoiceTab } from "../archives/invoicesTab";
import { BankStatementTab } from "../archives/bankStatementsTab";
import { DepositTab } from "../archives/depositsTab";
import { AsfInvoicesTab } from "../archives/asfInvoicesTab";
import "../../../../i18n/i18n";
import { selectManagersList } from "../../users/usersSlice";
import { supportPhonesByCompanyGroupUuid } from "../../../../constants/support";

export const BillingsArchives = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "invoices",
  );
  const company = useAppSelector(selectCompany);
  const manager = useAppSelector(selectManager);
  const managers = useAppSelector(selectManagersList);

  const otherSupportPhones = useMemo(
    () =>
      managers && managers.length > 0 && managers[0].companyGroup
        ? supportPhonesByCompanyGroupUuid[managers[0].companyGroup]
        : undefined,
    [managers],
  );

  const tabs = [
    {
      name: "invoices",
      title: t("billings.archives.tab.invoices"),
    },
    {
      name: "statements",
      title: t("billings.archives.tab.statements"),
    },
    {
      name: "bankStatements",
      title: t("billings.archives.tab.bankStatements"),
    },
    {
      name: "deposits",
      title: t("billings.archives.tab.deposits"),
    },
    {
      name: "asfInvoices",
      title: t("billings.archives.tab.asfInvoices"),
    },
  ];

  useEffect(() => {
    if (selectedTab) {
      navigate(`/home/billings/archives/${selectedTab}`);
    }
  }, [navigate, selectedTab]);

  if (!company || !manager) {
    return;
  }

  return (
    <PageDS
      title={t("billings.archives.title")}
      toaster={<ToastContainerDS />}
      titleElement={{
        closeButtonAction: () => {
          navigate("/home/billings/portal");
        },
        withoutLineSeparator: true,
      }}
      topElement={
        <TabMenu
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      }
      supportButton={{
        showMail: !otherSupportPhones,
        otherPhones: otherSupportPhones,
      }}
    >
      <StatementTab />
      <InvoiceTab />
      <BankStatementTab />
      <DepositTab />
      <AsfInvoicesTab />
    </PageDS>
  );
};
